import LegalPageLayout from './LegalPageLayout';
import { COMPANY_INFO } from '../constants/companyInfo';

export default function PrivacyPolicyPage() {
  return (
    <LegalPageLayout title="Gizlilik Politikası">
      <p>
        Bu gizlilik politikası, <strong>{COMPANY_INFO.name}</strong> tarafından işletilen dijital hizmetlerde işlenen kişisel
        verilere ilişkin esasları açıklar.
      </p>

      <h2>1. Toplanan Veriler</h2>
      <ul>
        <li>Kimlik ve iletişim bilgileri (ad soyad, e-posta, telefon)</li>
        <li>Başvuru ve iletişim formu içerikleri</li>
        <li>Teknik veriler (IP adresi, tarayıcı bilgisi, log kayıtları)</li>
        <li>Kullanım tercihleri ve işlem geçmişi</li>
      </ul>

      <h2>2. Veri İşleme Amaçları</h2>
      <ul>
        <li>Hizmet sunmak, geliştirmek ve güvenliğini sağlamak</li>
        <li>Kullanıcı taleplerini yanıtlamak</li>
        <li>Teklif, kampanya ve başvuru süreçlerini yürütmek</li>
        <li>Yasal yükümlülükleri yerine getirmek</li>
      </ul>

      <h2>3. Veri Saklama Süresi</h2>
      <p>
        Kişisel veriler; ilgili mevzuatın öngördüğü süre boyunca veya işleme amacının gerektirdiği makul süreler boyunca saklanır.
        Süre sonunda veriler silinir, yok edilir veya anonim hale getirilir.
      </p>

      <h2>4. Veri Aktarımı</h2>
      <p>
        Veriler; yasal zorunluluk bulunması, sözleşme süreçlerinin yürütülmesi veya teknik hizmet alınması durumlarında sınırlı ve
        ölçülü olarak yetkili kurumlara, iş ortaklarına ve altyapı sağlayıcılarına aktarılabilir.
      </p>

      <h2>5. Güvenlik</h2>
      <p>
        {COMPANY_INFO.name}, kişisel verilerin gizliliğini ve bütünlüğünü korumak için uygun teknik ve idari tedbirleri uygular.
      </p>

      <h2>6. Kullanıcı Hakları</h2>
      <p>
        Kullanıcılar; verilerine erişim, düzeltme, silme, işleme faaliyetini sınırlandırma ve itiraz haklarını ilgili mevzuat
        kapsamında kullanabilir.
      </p>

      <h2>7. İletişim</h2>
      <p>
        Gizlilik politikasıyla ilgili taleplerinizi <a href={`mailto:${COMPANY_INFO.email}`}>{COMPANY_INFO.email}</a> adresine
        iletebilirsiniz.
      </p>
    </LegalPageLayout>
  );
}
